module.exports = __webpack_public_path__ + "media/recipes/89-27028383.png";